export function initCatalogNavigation(root = document) {
  root.querySelectorAll('[data-nav-group]').forEach(group => {
    if (group.dataset.navReady) return;
    const button = group.querySelector('[data-nav-toggle]');
    const panel = group.querySelector('[data-nav-panel]');
    if (!button || !panel) return;
    group.dataset.navReady = 'true';
    let openedByHover = false;
    let closeTimer;
    const categories = [...group.querySelectorAll('[data-catalog-category]')];
    const previews = [...group.querySelectorAll('[data-catalog-products]')];
    let activeCategory = 0;
    const selectCategory = index => {
      activeCategory = index;
      categories.forEach((category, position) => {
        category.classList.toggle('is-active', position === index);
        category.querySelector('[data-catalog-category-toggle]')?.setAttribute('aria-expanded', String(position === index));
      });
      previews.forEach((preview, position) => { preview.hidden = position !== index; });
    };
    categories.forEach((category, index) => {
      category.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) selectCategory(index);
      });
      category.addEventListener('focusin', () => selectCategory(index));
      category.querySelector('[data-catalog-category-toggle]')?.addEventListener('click', () => selectCategory(index));
      category.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const next = (index + (event.key === 'ArrowDown' ? 1 : -1) + categories.length) % categories.length;
          categories[next].querySelector('[data-catalog-category-link]')?.focus();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          previews[index]?.querySelector('a')?.focus();
        }
      });
    });
    const setOpen = (open, byHover = false) => {
      clearTimeout(closeTimer);
      openedByHover = open && byHover;
      button.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
    };
    button.addEventListener('click', event => {
      // A pointer reaches the button before clicking: keep that hover-open menu open.
      setOpen(event.detail > 0 && openedByHover ? true : panel.hidden);
    });
    group.addEventListener('pointerenter', event => {
      clearTimeout(closeTimer);
      if (panel.hidden && event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) setOpen(true, true);
    });
    group.addEventListener('pointerleave', event => {
      if (event.pointerType === 'mouse' && !group.contains(document.activeElement)) closeTimer = setTimeout(() => setOpen(false), 180);
    });
    group.addEventListener('focusin', event => {
      if (event.target.matches('.catalog-nav__parent')) setOpen(true);
    });
    group.addEventListener('focusout', event => {
      if (!group.contains(event.relatedTarget)) setOpen(false);
    });
    group.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        button.focus({ preventScroll: true });
      }
      if (event.key === 'ArrowDown' && !panel.contains(event.target)) {
        event.preventDefault();
        setOpen(true);
        (panel.querySelector('[data-catalog-category-link]') || panel.querySelector('a'))?.focus();
      }
      if (event.key === 'ArrowLeft' && event.target.closest('[data-catalog-products]')) {
        event.preventDefault();
        categories[activeCategory]?.querySelector('[data-catalog-category-link]')?.focus();
      }
    });
    document.addEventListener('click', event => { if (!group.contains(event.target)) setOpen(false); });
    group.closest('details')?.addEventListener('toggle', event => { if (!event.target.open) setOpen(false); });
  });
}
if (typeof document !== 'undefined') {
  initCatalogNavigation();
  document.addEventListener('shopify:section:load', event => initCatalogNavigation(event.target));
}
